import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingDepositMatchOffer: false,
  loadingStatistics: false,
  depositMatchOffers: [],
  pagination: {
    page: 1,
    limit: 10,
    total: -1,
  },
  statistics: {
    activeOffers: 0,
    averageMatchPercentage: 0,
    redemptionRate: 0,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_DEPOSIT_MATCH_OFFER_LIST: (s, data) =>
      (s.loadingDepositMatchOffer = data),
    SET_DEPOSIT_MATCH_OFFERS: (s, data) => {
      s.depositMatchOffers = data.depositMatchOffers;
      s.pagination = data.pagination;
    },
    SET_DEPOSIT_MATCH_OFFER_STATISTICS: (s, data) => {
      s.statistics = data;
    },
    LOAD_DEPOSIT_MATCH_OFFER_STATISTICS: (s, data) =>
      (s.loadingStatistics = data),
  },

  actions: {
    async getDepositMatchOfferList({ commit }, params) {
      commit("LOAD_DEPOSIT_MATCH_OFFER_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/bonuses", {
          params,
        });
        const { data, pagination } = res.data;
        commit("SET_DEPOSIT_MATCH_OFFERS", {
          depositMatchOffers: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DEPOSIT_MATCH_OFFER_LIST", false);
      }
    },
    async getDepositMatchOfferStatistics({ commit }) {
      try {
        commit("LOAD_DEPOSIT_MATCH_OFFER_STATISTICS", true);
        const { data: res } = await this.$api.get(
          "/v1/portal/bonuses/statistics/all"
        );
        commit("SET_DEPOSIT_MATCH_OFFER_STATISTICS", res.data);
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DEPOSIT_MATCH_OFFER_STATISTICS", false);
      }
    },
    async deleteDepositMatchOffer({ dispatch }, id) {
      try {
        const { data: res } = await this.$api.delete(
          `/v1/portal/bonuses/${id}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async updateDepositMatchOffer({ dispatch }, { id, data }) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/bonuses/${id}`,
          data
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    
  },
};
